import { render, staticRenderFns } from "./CreatorsListItem.vue?vue&type=template&id=3f8b460a&scoped=true&"
import script from "./CreatorsListItem.vue?vue&type=script&lang=ts&"
export * from "./CreatorsListItem.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorsListItem.vue?vue&type=style&index=0&id=3f8b460a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b460a",
  null
  
)

export default component.exports